import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import { themeStyle as uiKitThemeStyle } from '@repo/ui-kit/themeStyle';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

import { FrequentlyAskedQuestionsProps } from './types';

export const Background = styled.div`
  width: 100%;
  background-color: ${themeStyle.varInkSuperLight};
`;

export const OneColumnContainer = styled(FlexColumn)<
  Pick<FrequentlyAskedQuestionsProps, 'variation'>
>`
  margin: 0 auto;
  align-items: flex-start;
  gap: 48px;

  ${QUERIES.largeTabletAndUp} {
    align-items: center;

    max-width: 661px;
  }
`;

export const TwoColumnsContainer = styled.div<
  Pick<FrequentlyAskedQuestionsProps, 'variation'>
>`
  display: flex;
  flex-direction: column;

  gap: 48px;

  ${QUERIES.largeTabletAndUp} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ItemWrapper = styled.div<{ isOpen: boolean }>`
  border-radius: ${themeStyle.radiusMedium};
  background: ${themeStyle.varBackgroundAlt};
  box-shadow: ${({ isOpen }) =>
    isOpen ? themeStyle.varShadowSmallFocus : 'unset'};
  max-width: 100%;
  width: 100%;

  cursor: pointer;
  box-sizing: border-box;

  border: 1px solid
    ${({ isOpen }) =>
      isOpen ? themeStyle.varBackgroundAlt : themeStyle.varInkLight};

  transition: box-shadow ${uiKitThemeStyle.motionDuration300} ease-in-out;
`;

export const ChevronWrapper = styled.div<{ isOpen: boolean }>`
  rotate: ${({ isOpen }) => (isOpen ? '180deg' : '0deg')};
  transition: rotate ${uiKitThemeStyle.motionDuration300} ease-in-out;
`;

export const TextWrapper = styled.div<{ isOpen: boolean }>`
  display: grid;
  grid-template-rows: ${({ isOpen }) => (isOpen ? '1fr' : '0fr')};
  transition: grid-template-rows ${uiKitThemeStyle.motionDuration300}
    ease-in-out;
`;

export const Text = styled.div`
  overflow: hidden;
`;
